import { TOrganizi8AppState } from '../organizi8.reducer';
import { CreateGRNActions, TCreateGRNActionTypes } from './create-grn.actions';

const initialState: TOrganizi8AppState['createGRN'] = {
  lotListing: {
    FABRIC: {},
    TRIMS: {},
  },
  lotDetails: {
    FABRIC: {},
    TRIMS: {},
  },
};

export const CreateGRNStateReducer = (
  state = initialState,
  action: TCreateGRNActionTypes,
): TOrganizi8AppState['createGRN'] => {
  switch (action.type) {
    case CreateGRNActions.ClearAndFetchFabricCreateGRNLotListing: {
      return {
        ...state,
        lotListing: {
          ...state.lotListing,
          FABRIC: {},
        },
      };
    }
    case CreateGRNActions.ClearAndFetchFabricCreateGRNLotListingSuccess: {
      return {
        ...state,
        lotListing: {
          ...state.lotListing,
          FABRIC: {
            res: action.res,
          },
        },
      };
    }
    case CreateGRNActions.ClearAndFetchTrimsCreateGRNLotListing: {
      return {
        ...state,
        lotListing: {
          ...state.lotListing,
          TRIMS: {},
        },
      };
    }
    case CreateGRNActions.ClearAndFetchTrimsCreateGRNLotListingSuccess: {
      return {
        ...state,
        lotListing: {
          ...state.lotListing,
          TRIMS: {
            res: action.res,
          },
        },
      };
    }
    case CreateGRNActions.ClearAndFetchFabricCreateGRNLotDetails: {
      return {
        ...state,
        lotDetails: {
          ...state.lotDetails,
          FABRIC: {},
        },
      };
    }
    case CreateGRNActions.ClearAndFetchFabricCreateGRNLotDetailsSuccess: {
      return {
        ...state,
        lotDetails: {
          ...state.lotDetails,
          FABRIC: {
            res: action.res,
          },
        },
      };
    }
    case CreateGRNActions.ClearAndFetchTrimsCreateGRNLotDetails: {
      return {
        ...state,
        lotDetails: {
          ...state.lotDetails,
          TRIMS: {},
        },
      };
    }
    case CreateGRNActions.ClearAndFetchTrimsCreateGRNLotDetailsSuccess: {
      return {
        ...state,
        lotDetails: {
          ...state.lotDetails,
          TRIMS: {
            res: action.res,
          },
        },
      };
    }
    default:
      return state;
  }
};
